import { IconRight } from '@ui/src';
import { AllTypesRowTypes } from './types';

import cn from './styles.module.css';

const AllTypesRow = ({
  onSelectRow,
  isSelectedRow,
  title,
  isEditable,
}: AllTypesRowTypes): React.JSX.Element =>
  onSelectRow ? (
    <button
      className={`${cn.allActionsRow} ${
        isSelectedRow ? cn.allActionsRowActive : ''
      }`}
      onClick={() => onSelectRow('all')}
      disabled={!isEditable}
      aria-label="select row"
      type="button"
    >
      <div className={cn.allActionsRowTitle}>{title}</div>
      <div className={cn.allActionsRowIcon}>
        <IconRight />
      </div>
    </button>
  ) : (
    <div />
  );

export default AllTypesRow;
